import {FC, ReactElement} from 'react';
import styled from 'styled-components';
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";

const Main = styled.div`
  width: 100%;
  padding: 0.72rem 0 0.36rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-size: 100% 100%;
  min-height: 100%;

  a {
    border: solid 0.01rem transparent;
    color: #08BDC7;
    min-width: 90%;
    font-size: 0.16rem;
    border-radius: 0.22rem;
    height: 0.44rem;
    text-align: center;
    line-height: 0.44rem;
    background-image: linear-gradient(#fbfaec, #eff6da), linear-gradient(164deg, rgba(72, 176, 254, 1), rgba(23, 250, 218, 1));
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
`;


const CertificationBtn = styled.div`
  height: 44px;
  background: linear-gradient(135deg, #49ADFF 0%, #1DEECE 100%);
  box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
  border-radius: 22px;
  text-align: center;
  line-height: 32px;
  margin-top: 0.44rem;
  font-weight: 600;
  color: #FFFFFF;
  padding: 5px 6px;
  width: 90%;

  div {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
    border-radius: 22px;
  }
`;
const Failure: FC = (): ReactElement => {
    const {t} = useTranslation();
    const history = useHistory()

    return (
        <>
            <Main>
                <img src={require('img/img_fail.png').default} style={{width: '1.4rem', marginTop: '0.2rem'}} alt=""/>
                <p style={{color: '#131314', fontSize: '0.18rem',marginTop:'0.24rem'}}>{t('home.FaceRecognitionFailed')}</p>
                <p style={{color: '#999999', fontSize: '0.12rem',marginTop:'0.08rem'}}>{t('home.YouTryAgain')}</p>
                <CertificationBtn onClick={() => history.push('/home')}>
                    <div>{t('home.tryAgain')}</div>
                </CertificationBtn>
                <p style={{color: '#08BDC7', fontSize: '0.16rem',marginTop:'0.2rem'}} onClick={() => history.push('/home')}>{t('home.backToHome')}</p>
            </Main>

        </>
    );
};

export default Failure;
